'use client'
import { useEffect, useState } from "react"; 

const useIsMobile = (size = 1000) : boolean =>  { 
  const [width, setWidth] = useState<number>(0);
	const handleWindowSizeChange = () => { 
		setWidth(window.innerWidth); 
	}; 

	useEffect(() => { 
		handleWindowSizeChange(); 
		window.addEventListener("resize", 
			handleWindowSizeChange); 

		return () => { 
			window.removeEventListener( 
				"resize", handleWindowSizeChange); 
		}; 
	}, []); 

	return width <= size; 
}; 

export default useIsMobile; 
